export type { CliAdapter, CliResult } from "./types.js";
export { CliRegistry } from "./registry.js";
export {
  ShellCliAdapter,
  type ShellCliAdapterOptions,
} from "./shell-adapter.js";
